module.exports = __webpack_public_path__ + "static/media/The_Japan_Foundation_-_B.f46ada2f.png";